class FacetsOpenDesktop extends HTMLElement {
  connectedCallback() {
    this._mql = window.matchMedia('(min-width: 750px)');
    this._onMediaChange = this._onMediaChange.bind(this);
    this._onInput = this._onInput.bind(this);

    this._mql.addEventListener('change', this._onMediaChange);
    this.addEventListener('input', this._onInput);

    FacetsOpenDesktop.syncDuplicateFacetInputs();
  }

  disconnectedCallback() {
    this._mql.removeEventListener('change', this._onMediaChange);
    this.removeEventListener('input', this._onInput);
  }

  _onMediaChange() {
    FacetsOpenDesktop.syncDuplicateFacetInputs();
  }

  _onInput(event) {
    const input = event.target;
    if (!input.matches || !input.matches('[data-open-facet-search]')) return;

    const panel = input.closest('.facets-open-inline__panel-inner');
    if (!panel) return;

    const list = panel.querySelector('[data-open-facet-list]');
    if (!list) return;

    const q = input.value.trim().toLowerCase();
    list.querySelectorAll('[data-open-facet-item]').forEach((li) => {
      const t = (li.dataset.searchText || '').toLowerCase();
      li.hidden = q.length > 0 && !t.includes(q);
    });
  }

  static syncDuplicateFacetInputs() {
    const desktop = window.matchMedia('(min-width: 750px)').matches;
    const openForm = document.getElementById('FacetFiltersFormOpenDesktop');
    if (!openForm) return;

    openForm.querySelectorAll('input, select, textarea').forEach((el) => {
      if (el.hasAttribute('data-open-facet-search')) {
        el.disabled = false;
        return;
      }
      el.disabled = !desktop;
    });

    document.querySelectorAll('[data-facet-open-desktop-sync-root]').forEach((root) => {
      root.querySelectorAll('input, select, textarea').forEach((el) => {
        el.disabled = desktop;
      });
    });
  }
}

customElements.define('facets-open-desktop', FacetsOpenDesktop);

window.syncOpenDesktopFacetInputs = FacetsOpenDesktop.syncDuplicateFacetInputs;
